const MODEL_FIELDS = Object.freeze({
  adCreatedRange: "adCreatedRange",
  adFirstPublishedRange: "adFirstPublishedRange",
  adLastPublishedRange: "adLastPublishedRange",
  adExpriedRange: "adExpriedRange",
  profileStatus: "profileStatus",
  pricingTier: "pricingTier",
  subscriptionStatus: "subscriptionStatus",
  sortBy: "sortBy",
  sortOrder: "sortOrder",
  sortDirection: "sortDirection",
  timeZone: "timeZone",
  residentCountry: "residentCountry",
});

const FIELD_TYPE = Object.freeze({
  dateRangeSelectorFilter: "dateRangeSelectorFilter",
  multiSelectFilterInput: "multiSelectFilterInput",
  dropdownSelector: "dropdownSelector",
  combinedSelectInput: "combinedSelectInput",
});

const FIELD_LEVEL = Object.freeze({
  primary: "primary",
  secondary: "secondary",
});

const SIDE_VIEW_VARAIENT = Object.freeze({
  addFollowUpComment: "addFollowUpComment",
});

const Config = Object.freeze({
  MODEL_FIELDS,
  FIELD_TYPE,
  FIELD_LEVEL,
  SIDE_VIEW_VARAIENT,
});

export default Config;
